import e from "./_arrayLikeKeys.js";
import i from "./_baseKeys.js";
import a from "./isArrayLike.js";
function f(r) {
  return a(r) ? e(r) : i(r);
}
export {
  f as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/keys.js
// module id = 241
// module chunks = 41